import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';
import { formatLocalDate } from '@/common/utils/dateFormats';

export const DateCell = ({ value }: { value?: Date }) =>
  value && <OverflowTooltip>{formatLocalDate(value)}</OverflowTooltip>;
